module.exports = __webpack_public_path__ + "img/C-02-min.806b0abb.png";